<app-menu></app-menu>

<router-outlet></router-outlet>   

 <app-footer></app-footer>
